<template lang="pug">
  b-row()
    //- Sección 1
    b-col(cols="4")
      b-row.row-title.pb-3
        b-icon-cash.mr-2
        h3.title Cotización

      //- Datos
      b-row.pb-2
        b-col.pl-0(:cols="ovData.comentario_vendedor !== '-' ? '12' : '5'")
          h4.data-label Comentario Vendedor
        b-col.pl-0.pr-4(cols="12" v-if="ovData.comentario_vendedor !== '-'")
          h4.data-info {{ ovData.comentario_vendedor }}
        b-col(cols="7" v-else)
          h4.data-info {{ ovData.comentario_vendedor }}

      b-row.pb-2
        b-col.pl-0(:cols="ovData.comentario_cierre !== '-' ? '12' : '5'")
          h4.data-label Comentario Cierre
        b-col.pl-0.pr-4(cols="12" v-if="ovData.comentario_cierre !== '-'")
          h4.data-info {{ ovData.comentario_cierre }}
        b-col(cols="7" v-else)
          h4.data-info {{ ovData.comentario_cierre }}

      b-row
        b-col.pl-0(cols="5")
          h4.data-label Abono Requerido
        b-col(cols="7")
          h4.data-info {{ ovData.abono_requerido | formatCurrency }}

      b-row
        b-col.pl-0(cols="5" )
          h4.data-label Monto Abonado
        b-col(cols="7" )
          h4.data-info {{ ovData.monto_abonado | formatCurrency }}

      b-row(v-if="ovData.saldo_pendiente > 0 && Number(ovData.monto_abonado) > 0")
        b-col.pl-0(cols="5" )
          h4.data-label Saldo Pendiente
        b-col(cols="7" )
          h4.data-info {{ ovData.saldo_pendiente | formatCurrency }}

      b-row.row-title.pb-3
        b-icon-receipt.mr-2
        h3.title Boletas

      b-row(v-if="ovData.requiere_abono")
        b-col.pl-0(cols="5" )
          h4.data-label N° de Boleta/Factura Abono
        b-col(cols="7" )
          h4.data-info {{ ovData.nro_boleta_abono }}

      b-row(v-if="ovData.requiere_abono")
        b-col.pl-0(cols="5")
          h4.data-label N° de Boleta/Factura Pago Final
        b-col(cols="7")
          h4.data-info {{ ovData.nro_boleta_pago }}


    //- Sección 2
    b-col(cols="8").pb-4
      b-row.row-title.pb-3
        b-icon-tools.mr-2
        h3.title Repuestos y Mano de Obra

      //- Tabla de Repuestos y Mano de Obra
      b-row
        b-table(hover :items="[ ...ovData.productos, ...ovData.servicios ]" :fields="fields")
          template(#cell(parte)="{item}")
            b-row(v-if="item.parte")
              span.product-code COD: {{ item.numero_parte || '-' }}
            b-row
              span.product-name {{ item.nombre || '-' }}
          template(#cell(precio_unitario)="{item}")
            div {{ (item.precio_unitario || '0') | formatCurrency }}
          template(#cell(precio_total)="{item}")
            div {{ (item.precio_total || '0') | formatCurrency }}


      //- Total de Tabla de Repuesto y Mano de Obra
      b-row.pt-4()
        b-col.pl-0(cols="8")
        b-col.pl-0(cols="4")
          b-row.border-top
            b-col
            b-col
              h4.total-table-label Sub-Total:
            b-col
              h4.total-table-info {{ ovData.monto_total_neto | formatCurrency }}
          b-row(v-if="ovData.descuento_en_pesos && ovData.descuento_en_pesos > 0")
            b-col
              h4.total-table-label Descuento:
            b-col
              h4.total-table-info -{{ ovData.descuento_en_pesos | formatCurrency }}
          b-row
            b-col
              h4.total-table-label IVA:
            b-col
              h4.total-table-info {{ ovData.iva | formatCurrency }}
          b-row.border-top
            b-col
              h4.total-table-label TOTAL:
            b-col
              h4.total-table-label(style="text-align: end !important") {{ ovData.monto_total_general | formatCurrency }}

</template>

<script>

export default {
  props: {
    ov: {
      type: Object,
      required: true,
    },
  },

  components: {
  },
  data() {
    return {
      fields: [
        { key:'parte' ,label: 'Producto' },
        { key:'cantidad' ,label: 'Cantidad' },
        { key:'precio_unitario' ,label: 'Precio Unitario' },
        { key:'precio_total' ,label: 'Total' },
      ],
    }
  },

  computed: {
    ovData () {

      // Se agrega el costo de envio en caso de que exista
      const productBase = this.ov.detalle_venta || [];
      const products = this.ov.costo_envio ? [...productBase, {
        precio_unitario: this.ov.costo_envio,
        precio_total: this.ov.costo_envio,
        cantidad: 1,
        parte: {
          part_number: 'Costo de Envio',
          description: 'Costo de Envio',
        },
      }] : productBase;

      return {
        comentario_vendedor: this.ov.comentario_vendedor || '-',
        comentario_cierre: this.ov.comentario_cierre || '-',
        requiere_abono: this.ov.requiere_abono ? 'Sí' : 'No',
        abono_requerido: this.ov.abono_requerido ? this.ov.abono_requerido.replace(/,/g, '') : '0',
        monto_abonado: this.ov.monto_abonado || '0',
        saldo_pendiente: this.ov.resumen_montos?.saldo_pendiente || 0,
        monto_total_neto: this.ov.monto_total_neto || '0',
        nro_boleta_abono: this.ov.nro_boleta_abono || '-',
        nro_boleta_pago: this.ov.nro_boleta_pago || '-',
        iva: this.ov.valor_iva || Math.floor((Number(this.ov.monto_total_neto) - (this.ov.monto_descuento || 0)) * 0.19).toString(),
        monto_total_general:
          this.ov.monto_total_final ||
          (
            Math.floor(
              (Number(this.ov.monto_total_neto) - (this.ov.monto_descuento || 0)) * 1.19
            ) + (this.ov.costo_envio || 0)
          ).toString(),
        productos: products.length > 0
          ? products.map((repuesto) => {
              return {
                ...repuesto,
                numero_parte: repuesto ? repuesto.parte.part_number : '',
                nombre: repuesto.parte ? repuesto.parte.description : '',
              }
            })
          : [],
        rut: this.ov.rut || '',
        nombre: this.ov.nombre || '',
        apellido: this.ov.apellido || '',
        correo_electronico: this.ov.correo_electronico || '',
        telefono: this.ov.telefono || '',
        region: this.ov.region || '',
        comuna: this.ov.comuna || '',
        direccion: this.ov.direccion || '',
        comentario: this.ov.comentario || '-',
        numero_serie_equipo: this.ov.numero_serie_equipo || '-',
        comentario_cliente: this.ov.comentario || '-',
        repuestos: this.ov.repuestos,
        descuento_en_pesos: this.ov.monto_descuento || '0',
        servicios: this.ov.servicios.length > 0
          ? this.ov.servicios.map((s) => {
            return {
              ...s,
              nombre: s.servicio ? s.servicio.nombre || 'servicio_sin_nombre' : 'servicio_sin_nombre',
              precio_unitario: s.precio ?? '0',
              cantidad: s.cantidad || 1,
              precio_total: s.precio ?? '0'
            }
          })
          : []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.label-text {
  color: $samtek-black !important;
}
.title {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}
.row-title {
  align-items: center;
}
.data-label {
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  justify-content: left;
  color: #525252;
  margin: 0;
}
.data-info {
  font-size: 14px;
  font-weight: 400;
  color: #525252;
  text-align: left;
}
.repuesto {
  color: #525252;
  font-size: 1rem;
}
.product-code {
  font-size: 11px;
  font-weight: 500;
  color: #525252;
}
.product-name {
  font-size: 14px;
  color: #23201C;
  font-weight: 500;
}
.total-table-label {
  font-size: 14px;
  font-weight: 700;
  text-align: start;
}
.total-table-info {
  font-size: 13px;
  font-weight: 500;
  color: #23201C;
  text-align: end;
}
</style>
